import React from 'react';
import PropTypes from 'prop-types';
import { useTouchpointData } from 'common/components/TouchpointEditor/contexts/TouchpointDataContext';

import {
    SIDE_BY_SIDE_LAYOUT,
    STACK_LAYOUT,
    SIDEBAR_LAYOUT,
    VIRTUAL_CONTENT_TYPE_EMBED,
    VIRTUAL_CONTENT_TYPE_LINK_OUT,
} from '../../../constants';

import VirtualContentContainer from './VirtualContent.styles';

const BASE_CLASS_NAME = 'VirtualContent';

export default function VirtualContent({ meta: { layout, virtualContentType }, children }) {
    const { embeds } = useTouchpointData();

    return (
        <VirtualContentContainer
            data-qa={`${BASE_CLASS_NAME}--container`}
            data-qa-layout={layout}
            data-qa-type={virtualContentType}
            $layout={layout}
            $virtualContentType={virtualContentType}
            $hasAltEmbed={embeds.data.hasAltEmbed && embeds.data.shouldRenderAltEmbed}
        >
            {children}
        </VirtualContentContainer>
    );
}

VirtualContent.propTypes = {
    children: PropTypes.node,
    meta: PropTypes.shape({
        layout: PropTypes.oneOf([SIDE_BY_SIDE_LAYOUT, STACK_LAYOUT, SIDEBAR_LAYOUT]),
        virtualContentType: PropTypes.oneOf([VIRTUAL_CONTENT_TYPE_EMBED, VIRTUAL_CONTENT_TYPE_LINK_OUT]),
    }).isRequired,
};

VirtualContent.defaultProps = {
    children: null,
};

VirtualContent.splash = {
    related: {},
    defaultProps: {
        meta: {
            layout: SIDE_BY_SIDE_LAYOUT,
            virtualContentType: VIRTUAL_CONTENT_TYPE_EMBED,
        },
    },
};
